import { Row } from "@narmi/design_system";
import styles from "./DrawerHeader.module.scss";
import { StatusTag } from "./";

const DrawerHeader = ({ title, status }: { title: string; status: string }) => (
  <Row alignItems="top">
    <Row.Item>
      <div className={styles.clampAndEllipsis}>
        <h1>{title}</h1>
      </div>
    </Row.Item>
    <Row.Item shrink>
      <div className="margin--top--xs">
        <StatusTag status={status} />
      </div>
    </Row.Item>
  </Row>
);

export default DrawerHeader;
